import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './page404.css';

const Page404 = React.memo( () => {
    const { localization: { content } } = useSelector( ( state ) => state );
    const { notFound: { title, description, btnTitle } } = content;
    const textH1 = title ? title : 'This is page 404';
    const textH5 = description ? description : 'Sorry, there is no such page.';
    const btnText = btnTitle ? btnTitle : 'Go to home page';

    return (
        <section className={ styles.wrapper }>
            <h1>{ textH1 }</h1>
            <h5>{ textH5 }</h5>
            <div className={ styles.btnWrapper }>
                <Link to={ '/' }>{ btnText }</Link>
            </div>
        </section> );
} );

export default Page404;